/**
 * The sharded gym counters — the shard count and the document layout, shared
 * by the client writer, the server writers and every server reader.
 *
 * A single counter document caps at ~1 write/sec, so every increment goes to
 * one of `gyms/{gymId}/counters/shard_{0..SHARD_COUNT-1}` and a read sums
 * them all. The number and the path used to be spelled by hand on both sides
 * (`10` and `shard_${i}` literals); a drift there would have been a reader
 * summing a shard nobody writes, or a writer feeding a shard nobody sums.
 *
 * Only the DATA is shared. The increment itself stays per SDK: the web SDK's
 * `increment` and the Admin SDK's `FieldValue.increment` are different objects
 * (`incrementShard` in the client `shardedCounter.js`, `incrementShardServer`
 * in `gymCleanup.js`).
 */
export const SHARD_COUNT = 10;

/** The counters subcollection of a gym. */
export function shardCollectionPath(gymId) {
  return `gyms/${gymId}/counters`;
}

/** The document id of one shard. */
export function shardDocId(index) {
  return `shard_${index}`;
}

/** The full path of one shard document. */
export function shardDocPath(gymId, index) {
  return `${shardCollectionPath(gymId)}/${shardDocId(index)}`;
}

/** A uniformly random shard index — the writers spread contention with it. */
export function randomShardIndex() {
  return Math.floor(Math.random() * SHARD_COUNT);
}
